module.exports = {"659009100":"老兵镇","659009101":"昆泉镇","659009102":"昆牧镇","659009103":"玉泉镇","659009400":"昆玉市核心区","659009500":"兵团二二四团","659009501":"北京皮墨工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/659009.json
// module id = 3301
// module chunks = 0